import { FC, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useHydrozoaHeadInfo } from "@/hooks/useHydrozoaScriptAddress";
import { formatAda } from "@/lib/utils";
import { AssetAmount } from "@sundaeswap/asset";

export const TvlBanner: FC = () => {
  const headInfo = useHydrozoaHeadInfo();
  const headAddress = headInfo?.headAddress;

  const { data: lovelace } = useQuery({
    queryKey: ["tvl", headAddress],
    enabled: !!headAddress,
    refetchInterval: 30_000,
    queryFn: async () => {
      const network = window.__APP_CONFIG.env === "mainnet" ? "mainnet" : "preview";
      const res = await fetch(
        `https://cardano-${network}.blockfrost.io/api/v0/addresses/${headAddress}`,
        {
          headers: {
            project_id: window.__APP_CONFIG.blockfrostProjectId,
          },
        },
      );
      if (!res.ok) return null;
      const data = await res.json();
      const ada = data.amount?.find(
        (a: { unit: string; quantity: string }) => a.unit === "lovelace",
      );
      return ada?.quantity ?? null;
    },
  });

  const formatted = useMemo(() => {
    if (!lovelace) return null;
    const amt = new AssetAmount(BigInt(lovelace), {
      decimals: 6,
      assetId: "ada.lovelace",
    });
    return formatAda(amt);
  }, [lovelace]);

  if (!formatted) return null;

  return (
    <div className="flex items-center justify-center gap-2 py-1.5 text-xs text-sr-neutral-500">
      <span>Total Value Locked:</span>
      <span className="text-sr-lemon-muted font-medium tabular-nums">
        {formatted} ADA
      </span>
    </div>
  );
};
